<template>
    <div class="p-0">
        <form @submit.prevent="validar">
            <p class="text-justify pb-5" v-if="credito">
                Autorizo (amos) expresa e irrevocablemente al concesionario  o a quien sea en el futuro el cesionario, beneficiario o acreedor de la venta a plazo solicitada, para que  obtenga cuantas veces sean necesarias, de cualquier  fuente de información, incluidos los buros de información crediticia, mi información de riesgos  crediticios, de igual forma, autorizo a corporación CFC S.A., o a quien sea en el futuro el cesionario, beneficiario y/o   acreedor de la venta a plazo solicitada, para que pueda transferir o entregar  dicha información a los buros de información crediticia y/o  a la central de riesgos si fuera pertinente
            </p>
            <p class="text-justify pb-5" v-else>
                Autorizo (amos)  expresa    e irrevocablemente  al concesionario   para que   obtenga cuantas  veces  sean  necesarias,  de  cualquier   fuente de  información,  mi información  personal de acuerdo a lo dispuesto por la UAFE.
            </p>
            <br>
            <div class="col-12 p-0">
                <label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand" for="carta">
                    <input type="checkbox" name="carta de autorización" id="carta" :value="true" v-model="formulario.autorizo" v-validate="{required:true}"> He leído la y acepto los términos de esta carta de autorización
                    <span></span>
                </label>
                <span class="form-text text-danger">{{ errors.first('carta de autorización') }}</span>
            </div>
            <div class="row pt-5">
                <div class="col-12 col-md-12 p-1">
                    <button type="submit" class="btn btn-primary btn-elevate btn-pill btn-block">Guardar</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        name: "autorizacion",
        data:()=>({
            formulario:{
                complete:false,
                autorizo:false
            },
            nombre:"Usuario",
            cargando:false,
        }),
        props:{
            credito:{
                type: Boolean,
                default: true,
            },
            sync: {
                type: Boolean,
                default: false,
            },
            previos: {
                type: Object
            },
            tipo: {
                type: Object
            },
        },
        computed:{
            ci:function(){
                return this.$store.getters.getDni;
            }
        },
        methods:{
            validar:function() {
                this.$validator.validateAll().then((result) => {
                    if(result){
                        this.formulario.complete=true;
                        this.$emit('input',this.formulario);
                    }else{
                        this.$toast.show(`Completa el formulario ` + this.tipo.titulo);
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
